import { createContext, ReactNode, useCallback, useMemo, useState } from 'react';

export type PresentationChromeContextType = {
	/** Ukrywa znaki wodne wersji / badge środowiska (tylko gdy nie produkcja — logika w komponentach). */
	hideDevChrome: boolean;
	setHideDevChrome: (value: boolean) => void;
};

const defaultValue: PresentationChromeContextType = {
	hideDevChrome: false,
	setHideDevChrome: () => {},
};

export const PresentationChromeContext = createContext<PresentationChromeContextType>(defaultValue);

export function PresentationChromeProvider({ children }: { children: ReactNode }) {
	const [hideDevChrome, setHideDevChromeState] = useState(false);
	const setHideDevChrome = useCallback((value: boolean) => {
		setHideDevChromeState(value);
	}, []);
	const value = useMemo(() => ({ hideDevChrome, setHideDevChrome }), [hideDevChrome, setHideDevChrome]);
	return <PresentationChromeContext.Provider value={value}>{children}</PresentationChromeContext.Provider>;
}
